import React from "react";
import PropTypes from "prop-types";

import { Button, Icon } from "semantic-ui-react";

import Form from "components/Form";
import { ControlledInput as FormInput } from "components/Form/ControlledInput/ControlledInput";

import { useFormName } from "./hooks";

export function FormBuilder({
  initialValue,
  onSubmit,
  onClose,
  showActions,
  onChange,
  loading,
}) {
  const { handleSubmit, formProps, isReady } = useFormName(onSubmit, onChange, {
    initialValue,
    showActions,
  });

  return (
    <Form {...formProps} onSubmit={handleSubmit}>
      <FormInput
        data-test="name-input"
        name="name"
        fluid
        placeholder="Form name"
        style={{ marginBottom: "0.5em", opacity: loading ? 0.45 : 1 }}
        disabled={loading}
        onKeyDown={(e) => {
          if (!showActions && e.key === "Enter") {
            e.preventDefault();
          }
        }}
      />
      {showActions && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Button
            content="Save"
            positive
            disabled={!isReady || loading}
            loading={loading}
          />
          <Icon
            data-test="close-icon"
            link
            name="delete"
            color="grey"
            size="large"
            onClick={onClose}
          />
        </div>
      )}
    </Form>
  );
}

FormBuilder.propTypes = {
  showActions: PropTypes.bool,
  initialValue: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

FormBuilder.defaultProps = {
  showActions: false,
  initialValue: "",
  loading: false,
};

export default FormBuilder;
